// extracted by mini-css-extract-plugin
export default {"scrollDownBtn":"scrollDownBtn_scrollDownBtn__a0doD","moveDown":"scrollDownBtn_moveDown__qhSWh"};